import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-business',
  templateUrl: './info-business.component.html',
  styleUrls: ['./info-business.component.scss']
})
export class InfoBusinessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
